
import {mapActions, mapGetters} from "vuex";
import { filter, get, map, uniq, uniqBy } from 'lodash'

export default {
    computed: {
        ...mapGetters({
            currentOrganizationId: 'e/users/currentOrganizationId',
            findOrganization: 'e/organizations/find',
        })
    },
    methods: {
        ...mapActions({

        }),
        organizationsFullPathByUserRoles(roles, currentOrganizationId = null){
            return map(
                this.extractItemByKeyAndUserRoles('organization', roles, currentOrganizationId),
                (organization) => {
                    let org = this.findOrganization(organization.id)
                    return org ? org.parentPath() : organization.name
                }
            ).join(', ')
        },
        organizationNamesByUserRoles(roles, currentOrganizationId = null){
            return this.extractNamesByKeyAndUserRoles('organization.name', roles, currentOrganizationId)
        },
        roleNamesByUserRoles(roles, currentOrganizationId = null) {
            return this.extractNamesByKeyAndUserRoles('role.name', roles, currentOrganizationId)
        },
        groupNamesByUserRoles(roles, currentOrganizationId = null) {
            return this.extractNamesByKeyAndUserRoles('group.name', roles, currentOrganizationId)
        },
        positionNamesByUserRoles(roles, currentOrganizationId = null) {
            return this.extractNamesByKeyAndUserRoles('position.name', roles, currentOrganizationId)
        },
        extractItemByKeyAndUserRoles(key, roles, currentOrganizationId = null, separator = ', ') {
            let temp = currentOrganizationId ? filter(roles, item => {
                return get(item, 'organization.id') === currentOrganizationId
            }) : roles
            return uniqBy(filter(map(temp, key)), 'id')
        },
        extractNamesByKeyAndUserRoles(key, roles, currentOrganizationId = null, separator = ', ') {
            let temp = currentOrganizationId ? filter(roles, item => {
                return get(item, 'organization.id') === currentOrganizationId
            }) : roles
            return uniq(filter(map(temp, key))).join(separator)
        }
    },
}
